<template>
  <!-- todo: fix props-->
  <div :class="[$attrs.class, $attrs.staticClass]"
       class="custom-spinner"
       data-cy="sdui-loader"
  />
</template>

<script>
export default {
  name: 'SduiLoader',
}
</script>
